import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import {IoCheckmarkCircle, IoAlertCircle, IoDocument, IoCloudUpload} from 'react-icons/io5';
import * as yup from 'yup';
import docIcon from './document.png';
import {MdDeleteForever} from "react-icons/md";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CaseFilesStatus from "../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import {Tooltip} from "@mui/material";
import LoaderCustom from "../ConfirmationModal/LoaderCustom";


const UploadMissingFilesExpert = ({caseFiles, permitTypeId, onClose, onFileAdded, onCaseStatusChange, showUploadMissingFiles}) => {
    const [fileTypes, setFileTypes] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState({});
    const [fileErrors, setFileErrors] = useState({});
    const [isUploading, setIsUploading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const fileInputRefs = useRef({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("");
    const params = new URLSearchParams(window.location.search);
    const caseType = parseInt(params.get('id'), 10);
    const [formattedFileNames, setFormattedFileNames] = useState({});
    const [isNoButtonDisabled, setIsNoButtonDisabled] = useState(false);
    const [modalText, setModalText] = useState("დარწმუნებული ხართ?");
    const [isAccelerationEnabled, setIsAccelerationEnabled] = useState(false);
    const [allRequiredUploaded, setAllRequiredUploaded] = useState(false);
    const [isLoadingFileTypes, setIsLoadingFileTypes] = useState(true);


    useEffect(() => {
        if (showUploadMissingFiles) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showUploadMissingFiles, onClose]);


    const checkAllRequiredUploaded = () => {
        const allUploaded = fileTypes.every(fileType => {
            return !fileType.required || (fileType.required && uploadedFiles[fileType.id]);
        });
        setAllRequiredUploaded(allUploaded);
    };
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleEscape);

        return () => window.removeEventListener('keydown', handleEscape);
    }, [onClose]);


    const fetchCaseDetails = async () => {
        try {
            const caseId = parseInt(params.get('id'), 10);
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetCaseByIdByuser?Id=${caseId}`);
            if (response.data.success) {
                setIsAccelerationEnabled(response.data.data.acceleration);
            } else {
            }
        } catch (error) {
        }
    };
    useEffect(() => {
        void fetchCaseDetails();
    }, []);

    useEffect(() => {
        if (isAccelerationEnabled !== undefined) {
            void fetchData();
        }
    }, [isAccelerationEnabled]);


    const fetchData = async () => {
        setIsLoadingFileTypes(true)
        await fetchCaseDetails()
        try {
            const responseFileTypes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllFileTypes`);
            if (responseFileTypes.data.success) {
                let allFileTypes = responseFileTypes.data.data.filter(type => type.caseId === permitTypeId);

                allFileTypes = allFileTypes.sort((a, b) => a.sort - b.sort);

                const uploadedFileTypeIds = new Set(caseFiles.map(file => file.fileTypeId));

                let missingFileTypes = allFileTypes.filter(type => !uploadedFileTypeIds.has(type.id));

                missingFileTypes = missingFileTypes.map(fileType => ({
                    ...fileType,
                    required: false,
                }));
                if (!isAccelerationEnabled) {
                    missingFileTypes = missingFileTypes.filter(fileType => !fileType.isCheck);
                }

                const newUploadProgress = {};
                const newUploadedFiles = {};
                const newFileErrors = {};
                const newFileInputRefs = {};

                missingFileTypes.forEach(fileType => {
                    newFileInputRefs[fileType.id] = React.createRef();
                    newUploadProgress[fileType.id] = 0;
                    newUploadedFiles[fileType.id] = null;
                    newFileErrors[fileType.id] = null;
                });

                setFileTypes(missingFileTypes);
                setUploadProgress(newUploadProgress);
                setUploadedFiles(newUploadedFiles);
                setFileErrors(newFileErrors);
                fileInputRefs.current = newFileInputRefs;
                setIsLoadingFileTypes(false)
            }
        } catch (error) {
        }
    };


    const handleBoxClick = (fileTypeId) => {
        fileInputRefs.current[fileTypeId].current.click();
    };


    const handleFileChange = (fileType, event) => {
        const file = event.target.files[0];
        if (file) {

            const maxSizeBytes = 5000 * 1048576;

            if (file.size > maxSizeBytes) {
                setFileErrors(prevState => ({
                        ...prevState,
                        [fileType.id]: `ფაილის ზომა აღემატება 5000MB.`

                    })
                );
                if (fileInputRefs.current[fileType.id]) {
                    fileInputRefs.current[fileType.id].current.value = "";
                }
                return; // Stop processing this file
            }
            let formattedName = file.name;
            if (formattedName.length > 30) {
                const fileExtension = formattedName.substring(formattedName.lastIndexOf('.'));
                formattedName = formattedName.substring(0, 27) + '...' + fileExtension;
            }

            setFormattedFileNames(prevState => ({...prevState, [fileType.id]: formattedName}));
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

            if (!fileType.extension.includes(fileExtension)) {
                setFileErrors(prevState => ({...prevState, [fileType.id]: "არასწორი ფორმატი!"}));
                setFormattedFileNames(prevState => ({...prevState, [fileType.id]: ''}));
            } else {
                setFileErrors(prevState => ({...prevState, [fileType.id]: null}));

                setUploadedFiles(prevState => ({...prevState, [fileType.id]: file}));

                let progress = 0;
                const interval = setInterval(() => {
                    progress += 10;
                    setUploadProgress(prevState => ({...prevState, [fileType.id]: progress}));
                    if (progress >= 100) {
                        clearInterval(interval);
                    }
                }, 200);
            }

            event.target.value = null;
            checkAllRequiredUploaded();
        }
    };

    const handleViewDocument = (fileType) => {
        const file = uploadedFiles[fileType.id];
        if (file) {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
            URL.revokeObjectURL(fileURL);
        }
    };

    const validateUploads = async () => {
        let schema = yup.object().shape({});
        fileTypes.forEach(fileType => {
            if (fileType.required) {
                schema = schema.shape({
                    [fileType.id]: yup.mixed().required(`დოკუმენტი სავალდებულოა!`)
                });
            }
        });

        try {
            await schema.validate(uploadedFiles, {abortEarly: false});
            return true;
        } catch (err) {
            err.inner.forEach(error => {
                setFileErrors(prev => ({...prev, [error.path]: error.message}));
            });
            return false;
        }
    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // Extracting the base64 part of the data URL
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = error => reject(error);
    });



    const performUpload = async () => {
        setIsUploading(true);
        setIsNoButtonDisabled(true);

        try {
            for (const fileType of fileTypes) {
                const file = uploadedFiles[fileType.id];
                if (file) {
                    const fileBase64 = await toBase64(file);
                    const name = fileType.title;
                    const fileData = {
                        caseID: caseType,
                        name: name,
                        ext: file.name.split('.').pop(),
                        file: fileBase64,
                        mainInfo: "",
                        additionalInfo: "",
                        shared: true,
                        blank: false,
                        documentType: 0,
                        internal: false,
                        status: CaseFilesStatus.Sent,
                        decline: CaseFileDeclined.No,
                        fileTypeId: fileType.id,
                        declinedInternalStatus: 0,
                        registeryDocumentType: fileType.registeryDocumentType,
                        inActiveIsInspectionSertificate: fileType.isinspectionSertificate
                    };

                    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData);
                }
            }

            setIsUploading(false);
            setIsNoButtonDisabled(false);
            setModalText("დარწმუნებული ხართ?");

            onCaseStatusChange()
            onFileAdded();

            setAlertMessage("Upload and Case Status Update successful!");
            setAlertType("success");
        } catch (error) {
            setAlertMessage("Error: " + error.message);
            setAlertType("error");
        } finally {
            setIsUploading(false);
            setIsModalOpen(false);

            onClose();
        }
    };


    const handleDeleteFile = (fileType) => {
        setUploadedFiles(prevState => ({...prevState, [fileType.id]: null}));
        setUploadProgress(prevState => ({...prevState, [fileType.id]: 0}));
        setFileErrors(prevState => ({...prevState, [fileType.id]: null}));
        setFormattedFileNames(prevState => ({...prevState, [fileType.id]: ''}));
        checkAllRequiredUploaded();
    };

    useEffect(() => {
        checkAllRequiredUploaded();
    }, [fileTypes, uploadedFiles]);
    const handleUploadFiles = async () => {
        if (!await validateUploads()) {
            return;
        }
        setIsModalOpen(true);
    };


    return (
        <div className={"upload-single-popup-missing-files"}>
            <div className="file-upload-page-missing-files">

                <div className="upload-heading">

                    <div className={"doc-page-title"}>დანართები</div>
                    <div>
                        <button className="reupload-close-btn" onClick={onClose}>&times;</button>
                        <div className="top-right-tooltip">
                            <Tooltip
                                title={(isUploading || !allRequiredUploaded) ? "განაცხადის რეგისტრაციისთვის ატვირთეთ ყველა სავალდებულო დოკუმენტი!" : ""}>
                                <button onClick={handleUploadFiles} disabled={ isUploading || !allRequiredUploaded}
                                        className="upload-button">
                                    <IoCloudUpload size="24px" className={"upload-icon"}/>
                                    {isUploading ? 'განაცხადი იგზავნება...' : 'დოკუმენტების დამატება'}
                                </button>
                            </Tooltip>
                        </div>

                    </div>
                </div>
                <div>
                </div>

                {isLoadingFileTypes && fileTypes.length === 0 ? (<LoaderCustom/>) : (
                    <div className="file-upload-container">
                        {fileTypes.map(fileType => (
                            <div>
                                <div key={fileType.id}
                                     className={`file-box ${uploadProgress[fileType.id] === 100 ? 'upload-complete' : ''}`}
                                     onClick={() => handleBoxClick(fileType.id)}>
                                    <img src={docIcon} alt="Document" className="document-icon"/>
                                    <div className="file-content">

                                        <div className="file-top">
                                            <div>
                                                <h4 className={"documnet-title"}>{fileType.title}</h4>
                                                <div className={"documnet-title"}>გაფართოება: {fileType.extension}</div>
                                                <div className={"documnet-title"}>მაქსიმალური
                                                    ზომა: 5000MB.
                                                </div>
                                                <div
                                                    className={"documnet-title"}>{formattedFileNames[fileType.id]}</div>
                                            </div>

                                            {fileType.required && uploadProgress[fileType.id] !== 100 && (
                                                <div className="icon-container">
                                                    <IoAlertCircle color="red" fontSize={"24px"}/>
                                                </div>
                                            )}
                                            {uploadProgress[fileType.id] === 100 && (
                                                <div className="icon-container">
                                                    <IoCheckmarkCircle size="24px" color="green"/>

                                                </div>
                                            )}

                                        </div>
                                        {fileErrors[fileType.id] &&
                                            <div className="error-message-doc">{fileErrors[fileType.id]}</div>}


                                        <input
                                            type="file"
                                            ref={fileInputRefs.current[fileType.id]}
                                            style={{display: 'none'}}
                                            accept={`${fileType.extension}`}
                                            onChange={(e) => handleFileChange(fileType, e)}
                                        />
                                    </div>
                                </div>
                                {uploadProgress[fileType.id] > 0 && uploadProgress[fileType.id] < 100 && (
                                    <div className="progress-bar-container">
                                        <div
                                            className="progress-bar-fill"
                                            style={{ width: `${uploadProgress[fileType.id]}%` }}
                                        ></div>
                                        <span className="progress-bar-text">
            {uploadProgress[fileType.id]}%
        </span>
                                    </div>
                                )}

                                {uploadProgress[fileType.id] === 100 && (
                                    <div className="documnet-actions-contaioner">

                                        <button className={"view-doc-button"}
                                                onClick={() => handleViewDocument(fileType)}>
                                            <IoDocument/> ნახვა
                                        </button>
                                        <button className={"view-del-button"}
                                                onClick={() => handleDeleteFile(fileType)}>
                                            <MdDeleteForever/> წაშლა
                                        </button>

                                    </div>

                                )}
                            </div>
                        ))}
                    </div>
                )}

            </div>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={performUpload}
                isNoButtonDisabled={isNoButtonDisabled}
                modalText={modalText}
            />
            {showAlert && (
                <CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setShowAlert(false)}
                />
            )}
        </div>
    );
};

export default UploadMissingFilesExpert;
